export default "__VITE_ASSET___YfIp7Vy__"